<template lang="pug">
  small(@click="show = !show")
    span.cursor-pointer(v-show="!show") Credits
    span(v-show="show") Design: <a @click.stop="doNothing" class="hover-italic" href="http://spencerfenton.co.uk" target="_blank" rel="noopener">Spencer Fenton</a> Build: <a @click.stop="doNothing" href="http://everettwilliams.info" class="hover-italic" target="_blank" rel="noopener">Everett Williams</a>
</template>

<script>
export default {
  name: 'Credits',
  data () {
    return {
      show: false
    }
  },
  methods: {
    doNothing () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Credits.vue